import { render, staticRenderFns } from "./CopyItemDialog.vue?vue&type=template&id=7c1ef00c"
import script from "./CopyItemDialog.vue?vue&type=script&lang=js"
export * from "./CopyItemDialog.vue?vue&type=script&lang=js"
import style0 from "./CopyItemDialog.vue?vue&type=style&index=0&id=7c1ef00c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports